import React from "react"
import { Col, Container, Row, CardTitle, Label, Input } from "reactstrap"
import { Link } from "react-router-dom"
import {
  addSpaceEveryNChars,
  checkExtension,
  getBusinsessAddress,
} from "helpers/common"
import pdfIcon from "../../../assets/images/icons/file-type.svg"
import imageIcon from "../../../assets/images/icons/image.svg"

const NonIndividualView = ({ investorData }) => {
  document.title = "Investor Details  | Prachay"

  const businessFiles = [
    { key: "initial_partnership_deed", label: "Initial Partnership Deed" },
    { key: "latest_partnership_deed", label: "Latest Partnership Deed" },
    {
      key: "certificate_of_incorporation",
      label: "Certificate of Incorporation",
    },
    { key: "gstin_certificate", label: "GSTIN Certificate" },
    { key: "memorandum_of_association", label: "Memorandum of Association" },
    { key: "articles_of_association", label: "Articles of Association" },
    { key: "initial_llp_deed", label: "Initial LLP Deed" },
    { key: "latest_llp_deed", label: "Latest LLP Deed" },
    { key: "huf_creation_document", label: "HUF Creation Document" },
    { key: "trust_deed", label: "Trust Deed" },
    { key: "society_bye_laws", label: "Society Bye-laws" },
  ]
  return (
    <React.Fragment>
      <div>
        <Row>
          <Col xl={12}>
            <Row className="mb-2">
              <Col xl={6}>
                <Label className="col-form-label">Name of the Entity</Label>
                <Input
                  disabled
                  name="name"
                  type="text"
                  className="form-control"
                  value={investorData?.investorCompanyDetails?.entity_name}
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">Date of Incorporation</Label>
                <Input
                  disabled
                  name="name"
                  type="text"
                  className="form-control"
                  value={
                    investorData?.investorCompanyDetails?.date_of_incorporation
                  }
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">
                  Constitution of Business
                </Label>
                <Input
                  disabled
                  name="name"
                  type="text"
                  className="form-control"
                  value={
                    investorData?.investorCompanyDetails
                      ?.constitution_of_business
                  }
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">Address</Label>
                <Input
                  disabled
                  name="name"
                  type="textarea"
                  className="form-control"
                  value={getBusinsessAddress(
                    investorData?.investorCompanyDetails
                  )}
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">PAN</Label>
                <Input
                  disabled
                  name="name"
                  type="text"
                  className="form-control"
                  value={investorData?.pan_no}
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">GSTIN</Label>
                <Input
                  disabled
                  name="name"
                  type="text"
                  className="form-control"
                  value={
                    investorData?.investorCompanyDetails?.gstin ||
                    "Not Applicable"
                  }
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">Phone No.</Label>
                <Input
                  disabled
                  name="phone"
                  type="text"
                  className="form-control"
                  value={investorData?.phone}
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">Email Address</Label>
                <Input
                  disabled
                  name="email"
                  type="text"
                  className="form-control"
                  value={investorData?.email}
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">Political Exposure</Label>
                <Input
                  disabled
                  name="email"
                  type="text"
                  className="form-control"
                  value={
                    investorData?.businessAdditionalDetails?.politicalExposure
                  }
                />
              </Col>
              <Col xl={6}>
                <Label className="col-form-label">
                  Entity Registration No.(
                  {showRegistrationType(
                    investorData?.businessAdditionalDetails
                      ?.constitution_of_business
                  )}
                  )
                </Label>
                <Input
                  disabled
                  name="email"
                  type="text"
                  className="form-control"
                  value={
                    investorData?.businessAdditionalDetails
                      ?.entity_registration_no
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Bank Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Account Holders Name
                    </Label>
                    <Input
                      disabled
                      name="account_holder"
                      type="text"
                      className="form-control"
                      value={investorData?.investorsBankDetails?.account_holder}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Number</Label>
                    <Input
                      disabled
                      name="account_no"
                      type="text"
                      className="form-control"
                      value={investorData?.investorsBankDetails?.account_no}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Bank Name</Label>
                    <Input
                      disabled
                      name="bank_name"
                      type="text"
                      className="form-control"
                      value={investorData?.investorsBankDetails?.bank_name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">IFSC</Label>
                    <Input
                      disabled
                      name="ifsc"
                      type="text"
                      className="form-control"
                      value={investorData?.investorsBankDetails?.ifsc}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>

        {investorData?.investorsDematDetails && (
          <Row>
            <Col xl={12}>
              <div>
                <div>
                  <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                    <CardTitle className="">Demat Details</CardTitle>
                  </div>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Demat Account Number
                      </Label>
                      <Input
                        disabled
                        name="demat_account_no"
                        type="text"
                        className="form-control"
                        value={
                          investorData?.investorsDematDetails?.demat_account_no
                        }
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Depository Participant Name
                      </Label>
                      <Input
                        disabled
                        name="depository_participant_name"
                        type="text"
                        className="form-control"
                        value={
                          investorData?.investorsDematDetails
                            ?.depository_participant_name
                        }
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Depository Name</Label>
                      <Input
                        disabled
                        name="exchange_type"
                        type="text"
                        className="form-control"
                        value={
                          investorData?.investorsDematDetails?.exchange_type
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Authorised Person Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Name</Label>
                    <Input
                      disabled
                      name="demat_account_no"
                      type="text"
                      className="form-control"
                      value={investorData?.investorsAadhaar?.name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Date of Birth</Label>
                    <Input
                      disabled
                      name="depository_participant_name"
                      type="text"
                      className="form-control"
                      value={investorData?.investorsAadhaar?.dob}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">PAN</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={investorData?.investorsPAN?.pan}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Aadhaar No.</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={investorData?.investorsAadhaar?.aadhaar_no}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Designation</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={
                        investorData?.businessAdditionalDetails?.designation
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">DIN</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={
                        investorData?.businessAdditionalDetails?.dpin ??
                        "Not Applicable"
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xl={12}>
            <CardTitle className="mt-4 mb-4">Documents</CardTitle>

            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Entity Documents
            </CardTitle>
            <div className="documents-section">
              {businessFiles.map((item, index) => (
                <React.Fragment key={`businessFiles_${index}`}>
                  {investorData?.businessAdditionalDetails?.[item.key] && (
                    <div className="documents-box">
                      <div className="file-type">
                        {checkExtension(
                          investorData?.businessAdditionalDetails?.[item.key]
                        ) === "pdf" ? (
                          <img src={pdfIcon} alt="" />
                        ) : (
                          <img src={imageIcon} alt="" />
                        )}

                        <div>
                          <p>{item.label}</p>
                          <Link
                            to={
                              investorData?.businessAdditionalDetails?.[
                                `${item.key}_url`
                              ]
                            }
                            target="_blank"
                          >
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <div className="verified-user">
                          <img src={check} alt="" /> Verified
                        </div> */}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>

            <hr className="my-4" />
            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Authorised Person Documents
            </CardTitle>
            <div className="documents-section">
              {investorData?.investorsAadhaar?.aadhaar_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      investorData?.investorsAadhaar.aadhaar_file_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Aadhaar</p>
                      <Link
                        to={investorData?.investorsAadhaar.aadhaar_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {investorData?.avatar_url && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(investorData?.avatar_url) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Selfie</p>
                      <Link to={investorData?.avatar_url} target="_blank">
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {investorData?.investorsPAN?.pan_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      investorData?.investorsPAN?.pan_file_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>PAN</p>
                      <Link
                        to={investorData?.investorsPAN?.pan_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}

              {investorData?.businessAdditionalDetails?.authority_letter && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      investorData?.businessAdditionalDetails
                        ?.authority_letter_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Authority Letter</p>
                      <Link
                        to={
                          investorData?.businessAdditionalDetails
                            ?.authority_letter_url
                        }
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
            </div>

            <hr className="my-4" />
            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Banking Documents
            </CardTitle>
            <div className="documents-section">
              {investorData?.investorsDematDetails?.cml_report && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      investorData?.investorsDematDetails?.cml_report_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>CML Report</p>
                      <Link
                        to={investorData?.investorsDematDetails.cml_report_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {investorData?.investorsBankDetails?.cheque_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      investorData?.investorsBankDetails.cheque_file_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Cheque</p>
                      <Link
                        to={investorData?.investorsBankDetails.cheque_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default NonIndividualView
